import React from "react"
import s from "./Success.module.scss"
import { getCurrentLanguage } from "../../../../helper"

const Success = ({ type, location }) => {
  const { lang } = getCurrentLanguage(location)

  const titleSent = {
    de: `Vielen Dank für deine Teilnahme! Bitte bestätige diese per Link, den wir soeben an deine E-Mail Adresse verschickt haben.`,
    fr: `Merci pour ta participation! Merci de confirmer via le lien que nous venons d'envoyer à ton adresse e-mail.`,
    fr_fr: `Merci pour ta participation! Merci de confirmer via le lien que nous venons d'envoyer à ton adresse e-mail.`,
    lu_fr: `Merci pour ta participation! Merci de confirmer via le lien que nous venons d'envoyer à ton adresse e-mail.`,
    it: `Grazie per la tua partecipazione! Conferma la tua iscrizione tramite il link che ti abbiamo appena inviato al tuo indirizzo e-mail.`,
  }
  const titleConfirmed = {
    de: `Vielen Dank - wir haben deine Teilnahme registriert.`,
    fr: `Merci beaucoup - nous avons enregistré ta participation.`,
    fr_fr: `Merci beaucoup - nous avons enregistré ta participation.`,
    lu_fr: `Merci beaucoup - nous avons enregistré ta participation.`,
    it: `Grazie, abbiamo registrato la tua partecipazione.`,
  }
  return (
    <section className={s.section}>
      <div className={s.failed_description}>
        <h2>{type === "confirm" ? titleConfirmed[lang] : titleSent[lang]}</h2>
      </div>
    </section>
  )
}

export default Success
